import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./lang/i18n";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./contexts/userContext.tsx";
import { LogoutModalProvider } from "./contexts/logoutModalContext";


createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <UserProvider>
          <LogoutModalProvider>
            <App />
          </LogoutModalProvider>
        </UserProvider>
      </BrowserRouter>
    </StrictMode>
);
